import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from "@material-ui/core";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const RouteTable = ({ onAdded, onSelectItem }) => {

    const classes = useStyles();
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        const fetchEmployees = async () => {
            await fetch('http://biometick.com/all-routes/' + localStorage.getItem("userID"), {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.length > 0) {
                        setEmployees(data);
                    }
                })
                .catch(error => console.error(error));
        };
        fetchEmployees();
    }, []);

    const handleEdit = (item) => {
        // Navigate to edit location page
        onSelectItem(item);
        onAdded('modify');
    };

    const handleDeleteCompany = (id) => {
        fetch(`http://biometick.com/delete-routes/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            if (res.ok) {
                setEmployees(employees.filter(location => location._id !== id));
            } else {
                throw new Error('Something went wrong');
            }
        }).catch(error => console.error(error));
    }

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="company table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell >Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {employees.map((employee) => {
                        return <TableRow key={employee._id}>
                            <TableCell style={{ fontSize: '12px', fontWeight: 'bold' }}>{employee.name}</TableCell>
                            <TableCell style={{ fontSize: '12px', fontWeight: 'bold' }}>{employee.address}</TableCell>
                            <TableCell >
                                <Button color="primary" style={{ fontSize: '12px', fontWeight: 'bold' }} onClick={() => handleEdit(employee)}>Edit</Button>
                                <Button color="secondary" style={{ fontSize: '12px', fontWeight: 'bold' }} onClick={() => handleDeleteCompany(employee._id)}>Delete</Button>
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RouteTable;